module.exports = {
  footerText: 'E-Pakit © 2020',
}
